import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

const TONE: Record<BadgeTone, string> = {
  neutral: 'bg-bg-alt text-ink-muted',
  accent: 'bg-accent-light text-accent-deep',
  success: 'bg-success/10 text-success-dark',
  warning: 'bg-warning/10 text-warning-dark',
  danger: 'bg-danger/10 text-danger',
  info: 'bg-info/10 text-info',
};

export function Badge({
  children,
  tone = 'neutral',
  className,
}: {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}) {
  return (
    <span
      className={cx(
        'inline-flex items-center rounded-pill px-3 py-1 text-[11px] tracking-[0.3px]',
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
